export interface MapAssetRegistryEntry {
  readonly mapId: string;
  readonly assetPath: string;
  readonly pickerId: string;
}

const MAP_ASSET_BASE_PATH = 'maps';

function createMapAssetRegistryEntry(mapId: string): MapAssetRegistryEntry {
  return {
    mapId,
    assetPath: `${MAP_ASSET_BASE_PATH}/${mapId}.json`,
    pickerId: `mmo-map-asset-${mapId}`,
  };
}

export const MAP_ASSET_REGISTRY: readonly MapAssetRegistryEntry[] = [
  createMapAssetRegistryEntry('grass_starter'),
  createMapAssetRegistryEntry('overworld_west'),
  createMapAssetRegistryEntry('overworld_east'),
  createMapAssetRegistryEntry('overworld_north'),
  createMapAssetRegistryEntry('overworld_south'),
];

const mapAssetRegistryById = new Map(
  MAP_ASSET_REGISTRY.map((entry) => [entry.mapId, entry] as const),
);

export function getMapAssetRegistryEntry(mapId: string): MapAssetRegistryEntry | null {
  return mapAssetRegistryById.get(mapId) ?? createMapAssetRegistryEntry(mapId);
}

export function getMapAssetPath(mapId: string): string {
  return getMapAssetRegistryEntry(mapId)?.assetPath ?? `${MAP_ASSET_BASE_PATH}/${mapId}.json`;
}
